angular.module('Itao.IndicatorMap').factory('DataLayerService', function () {
  'use strict';

  /**
   *
   * @param {Object} layer the dataLayer
   * @param {String} districtUid the districtUid
   * @param {String} indicatorUid the indicatorUid
   * @returns {*}
   */
  function getValueForDistrictAndIndicator(layer, districtUid, indicatorUid) {
    if(layer.hasOwnProperty(districtUid) && layer[districtUid].hasOwnProperty(indicatorUid)) {
      return layer[districtUid][indicatorUid];
    } else {
      return null;
    }
  }

  /**
   *
   * @param {Object} layer the dataLayer
   * @param {String} indicatorUid the indicatorUid
   * @returns {number} the maximum value for the given indicator
   */
  function getMaxValueForIndicator(layer, indicatorUid) {
    var values = [];
    for(var districtUid in layer.districts) {
      if(layer.districts.hasOwnProperty(districtUid)) {
        values.push(getValueForDistrictAndIndicator(layer, districtUid, indicatorUid));
      }
    }
    return Math.max.apply(null, values);
  }

  return {
    getValueForDistrictAndIndicator: getValueForDistrictAndIndicator,
    getMaxValueForIndicator: getMaxValueForIndicator
  };
});
